import type { PlgHomeProduct } from './apis/home-api';
import { stringifyQuery, type LocationQueryRaw } from 'vue-router';

export const IP_HOME_HREF = '/ip/checking/#/home';

const CONTROL_PLG_HOME_PRODUCT_MAP: Record<string, PlgHomeProduct> = {
    eureka_rd_landingpage: 'RD',
    eureka_ip_searching_landingpage: 'IP',
};

export function getIpHomeHref(query: LocationQueryRaw): string {
    const queryString = stringifyQuery(query);
    return queryString ? `${IP_HOME_HREF}?${queryString}` : IP_HOME_HREF;
}

export function getControlPlgHome(product: unknown): PlgHomeProduct | undefined {
    return typeof product === 'string' ? CONTROL_PLG_HOME_PRODUCT_MAP[product] : undefined;
}
